import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "~/lib/utils";

interface GreeterProps extends HTMLAttributes<HTMLDivElement> {
  children: Readonly<ReactNode>
  className?: string;

}
export default function GreeterRoot({ children, className, ...props }: GreeterProps) {
  return (
    <div className={cn("mt-12 mb-24 flex flex-col gap-1 text-center xl:gap-2", className)} {...props}>
      {children}
    </div>
  );
}
